import React, { ReactNode } from 'react';
import { HistoryLogActions } from './HistoryLogActions';
import { Trans as TransNoMacro } from '@lingui/react';
import { Trans } from '@lingui/react/macro';

type TranslationGenerator = () => ReactNode;

class TranslationMapping {
    private _map = new Map<string, TranslationGenerator>();

    private generateKey(operationKey: HistoryLogActions['All'], propertyName: string) {
        return `${operationKey}.${propertyName}`;
    }

    add(operationKey: HistoryLogActions['All'], propertyName: string, translation: TranslationGenerator) {
        this._map.set(this.generateKey(operationKey, propertyName), translation);
    }

    get(operationKey: HistoryLogActions['All'], propertyName: string) {
        const generator = this._map.get(this.generateKey(operationKey, propertyName));

        if (generator) {
            return generator();
        }

        return <TransNoMacro id={propertyName} />;
    }
}

const transMap = new TranslationMapping();

transMap.add('PricingFieldUpdated', 'Unit', () => <Trans>Unit of measure</Trans>);

transMap.add('WhiteLabelUpdated', 'ButtonColor', () => <Trans>Button background color</Trans>);
transMap.add('WhiteLabelUpdated', 'ButtonColorContrast', () => <Trans>Button text color</Trans>);
transMap.add('WhiteLabelUpdated', 'NotificationColor', () => <Trans>Notification indicator background color</Trans>);
transMap.add('WhiteLabelUpdated', 'NotificationColorContrast', () => <Trans>Notification indicator text color</Trans>);
transMap.add('WhiteLabelUpdated', 'IsEnabled', () => <Trans>Enabled</Trans>);
transMap.add('WhiteLabelUpdated', 'LogoUserFileId', () => <Trans>Company logo</Trans>);

transMap.add('TermsUpdated', 'TermsAndConditions', () => <Trans>Terms and conditions</Trans>);
transMap.add('TermsUpdated', 'ExternalPrivacyPolicyLink', () => <Trans>Project privacy policy link</Trans>);

transMap.add('ProjectTermsAndConditionsUpdated', 'TermsAndConditions', () => <Trans>Terms and conditions</Trans>);
transMap.add('ProjectTermsAndConditionsUpdated', 'ExternalPrivacyPolicyLink', () => (
    <Trans>Project privacy policy link</Trans>
));

transMap.add('ProjectOptionTermsUpdated', 'OptionsTermsEnabled', () => <Trans>Option terms enabled</Trans>);
transMap.add('ProjectOptionTermsUpdated', 'OptionsTermsText', () => <Trans>Option terms text</Trans>);

transMap.add('DeadlineAlertUpdated', 'DaysBeforeDeadline', () => <Trans>Number of days before deadline</Trans>);
transMap.add('DeadlineAlertUpdated', 'SendEmail', () => <Trans>Email</Trans>);
transMap.add('DeadlineAlertUpdated', 'SendSms', () => <Trans>SMS</Trans>);
transMap.add('DeadlineUpdated', 'IsChangeRequestDeadline', () => <Trans>Use as change request deadline</Trans>);

transMap.add('LandingPageMilestonesUpdated', 'IsCompleted', () => <Trans>Milestone marked</Trans>);
transMap.add('LandingPageImageTextChange', 'Text', () => <Trans>Image text</Trans>);

transMap.add('ProjectSettingsUpdated', 'DefaultLanguageCode', () => <Trans>Default language</Trans>);
transMap.add('ProjectSettingsUpdated', 'CurrencyCode', () => <Trans>Currency</Trans>);
transMap.add('ProjectSettingsUpdated', 'ChangeRequestWarningText', () => <Trans>Change request warning</Trans>);
// transMap.add('ProjectSettingsUpdated', 'Subdomain', () => <Trans>Subdomain</Trans>);
transMap.add('ProjectSettingsUpdated', 'DefaultShowOfferSubtotalsToBuyers', () => <Trans>Show subtotals to buyers</Trans>);
transMap.add('ProjectSettingsUpdated', 'ShowLandingPageBackgroundImage', () => (
    <Trans>Use project image as background for landing page</Trans>
));
transMap.add('ProjectSettingsUpdated', 'EmailContactInfo', () => <Trans>Contact information in invitation emails</Trans>);
transMap.add('ProjectSettingsUpdated', 'BuyerOptionOneTimeFee', () => <Trans>One-time fee for selecting options</Trans>);
transMap.add('ProjectSettingsUpdated', 'ShowDefaultTextOnOptions', () => (
    <Trans>Show (Default) on products for buyers</Trans>
));
transMap.add('ProjectSettingsUpdated', 'UseLegacyOptionsView', () => <Trans>Use legacy options view</Trans>);
transMap.add('ProjectSettingsUpdated', 'UseRooms', () => <Trans>Enable rooms</Trans>);
transMap.add('ProjectSettingsUpdated', 'Use3dConfigurator', () => <Trans>Enable 3D configurator</Trans>);
transMap.add('ProjectSettingsUpdated', 'DecimalOption', () => <Trans>Number of decimals shown</Trans>);
transMap.add('ProjectSettingsUpdated', 'AbsolutePricing', () => <Trans>Pricing mode</Trans>);

transMap.add('FileChanged', 'IsSensitive', () => <Trans>One-time fee for selecting options</Trans>);
transMap.add('FileChanged', 'HideFromBuyer', () => <Trans>Hide from buyer</Trans>);
transMap.add('Updated', 'ParticipantsNote', () => <Trans>Note for participants</Trans>);
transMap.add('Updated', 'Description', () => <Trans>Description</Trans>);
transMap.add('Updated', 'UpdateDate', () => <Trans>Update date</Trans>);

transMap.add('LandingPageMilestonesUpdated', 'Label', () => <Trans>Milestone title</Trans>);
transMap.add('LandingPageMilestoneCreated', 'Label', () => <Trans>Milestone title</Trans>);

export function getHistoryLogComparisonTranslation(operationKey: HistoryLogActions['All'], propertyName: string) {
    return transMap.get(operationKey, propertyName);
}

/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable @typescript-eslint/no-unused-expressions */
<Trans id="PricingFieldId">PricingFieldId</Trans>;
<Trans id="ProjectDeadlineId">ProjectDeadlineId</Trans>;
<Trans id="ShowQuantityToBuyers">ShowQuantityToBuyers</Trans>;
<Trans id="IsArchived">IsArchived</Trans>;
<Trans id="IsSensitive">IsSensitive</Trans>;
<Trans id="HideFromBuyer">HideFromBuyer</Trans>;
<Trans id="SortOrder">SortOrder</Trans>;
<Trans id="HasDirectCost">HasDirectCost</Trans>;
<Trans id="ProjectFeeSetId">ProjectFeeSetId</Trans>;
<Trans id="FeeSetId">FeeSetId</Trans>;
<Trans id="InternalDescription">InternalDescription</Trans>;
